import * as React from 'react';
import HttpStatus from 'http-status';

import { useNavigate } from 'react-router-dom';

import api from '../api';

const useAuth = () => {

    const navigate = useNavigate();

    const [authenticated, setAuthenticated] = React.useState(false);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
            setAuthenticated(true);
        } else {
            navigate('/login');
        }
    }, [authenticated]);

    const handleLogin = async (login, password) => {
        return await api.post('/login/user', { login: login, password: password }, {}).then((response) => {
            if (response.status === HttpStatus.OK) {
                var token = response.data.token;
                var user = response.data.user;
                var subscription = response.data.subscription;
                var profiles = response.data.profiles;
                var permissions = response.data.permissions;
                localStorage.setItem('token', JSON.stringify(token));
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem('profiles', JSON.stringify(profiles));
                localStorage.setItem('permissions', JSON.stringify(permissions));
                localStorage.setItem('subscription', JSON.stringify(subscription));
                api.defaults.headers.Authorization = `Bearer ${token}`;
                setAuthenticated(true);
                return "/main";
            } else {
                handleLogout();
                return null;
            }
        }).catch((error) => {
            handleLogout();
            return null;
        })
    }

    const handleLogout = () => {
        setAuthenticated(false);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('profiles');
        localStorage.removeItem('permissions');
        localStorage.removeItem('subscription');
        api.defaults.headers.Authorization = null;
    }

    const authenticatedUser = () => {
        var user = null;
        try {
            user = localStorage.getItem('user');
            if (user) {
                return JSON.parse(user);
            }
        } catch (error) {
            return null;
        }
        return user;
    }

    const userSubscription = () => {
        var subscription = null;
        try {
            subscription = localStorage.getItem('subscription');
            if (subscription) {
                return JSON.parse(subscription);
            }
        } catch (error) {
            return null;
        }
        return subscription;
    }

    const userPermissions = () => {
        var permissions = [];
        try {
            permissions = localStorage.getItem('permissions');
            if (permissions) {
                return JSON.parse(permissions);
            }
        } catch (error) {
            return [];
        }
        return permissions;
    }

    const userProfiles = () => {
        var profiles = [];
        try {
            profiles = localStorage.getItem('profiles');
            if (profiles) {
                return JSON.parse(profiles);
            }
        } catch (error) {
            return [];
        }
        return profiles;
    }

    const isDisabled = (resource, rule) => {
        if (isVisible(resource, rule)) {
            const permissions = userPermissions();
            for (let index = 0; index < permissions.length; index++) {
                const element = permissions[index];
                if (resource === element.target) {
                    return !(element.enabled && ((rule != undefined) ? rule : true));
                }
            }
            return true;
        } else {
            return true;
        }
    }

    const isVisible = (resource, rule) => {
        const permissions = userPermissions();
        for (let index = 0; index < permissions.length; index++) {
            const element = permissions[index];
            if (resource === element.target) {
                return (element.visible && ((rule != undefined) ? rule : true));
            }
        }
        return false;
    }

    return { authenticated, authenticatedUser, userSubscription, userProfiles, userPermissions, handleLogin, handleLogout, isDisabled, isVisible };
}

export default useAuth;